import styled from 'styled-components';
//import BG from '../../assets/images/background-login-imilk.png';

export const Main = styled.div`
    ${({ isAppWeb, isStore, isImilk }) => isImilk ? `background: #320533` : `background: #490026`};
    background-size: cover;
    min-height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
    
    @media (min-width: 1200px) {
      ${({ isAppWeb, isStore, isImilk }) => isImilk ? `background: #320533` : `background: #490026`};
      background-size: cover;
    }
    
    @media (max-width: 768px) {
      ${({ isAppWeb, isStore, isImilk }) => isImilk ? `background: #320533` : `background: #490026`};
      background-size: cover;
    }
`;

export const Wrapper = styled.div`
  width: 90vw;
  margin: ${({ isImilk }) => isImilk ? '130px auto auto auto;' : 'auto;'};
  justify-content: center;  
  background: ${({backgroundForm = '#fff'}) => backgroundForm ? `${backgroundForm}` : '#fff'};    
  box-sizing: border-box;
  box-shadow: 0 15px 33px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  z-index: 2;
  @media (min-width: 768px) {
    width: ${({ width = 362 }) => `${width}px`};
  }

  // @media (max-width: 1500px) {
  //   margin: ${({ isImilk }) => isImilk ? '30px auto auto auto;' : 'auto;'};
  // }

  @media (max-width: 1400px) {
    margin: ${({ isImilk }) => isImilk ? '30px auto auto auto;' : 'auto;'};
    width: 35vw;
    height: 350px;
  }

  @media (max-width: 1000px) {
    margin: ${({ isImilk }) => isImilk ? '10px auto auto auto;' : 'auto;'};
    width: 40vw;
    height: 310px;
  }

  // @media (max-width: 900px) {
  //   margin: ${({ isImilk }) => isImilk ? '10px auto auto auto;' : 'auto;'};
  //   width: 40vw;
  //   height: 310px;
  // }

`;

export const WrapperLoja = styled.div`
  width: 90vw;
  margin: 330px auto auto auto;
  justify-content: center;  
  background: ${({ backgroundForm = '#fff' }) => backgroundForm ? `${backgroundForm}` : '#fff'};    
  box-sizing: border-box;
  box-shadow: 0 15px 33px rgba(0, 0, 0, 0.25);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  padding: 24px;
  z-index: 2;
  @media (min-width: 768px) {
    width: ${({ width = 362 }) => `${width}px`};
  }
`;

const Column = styled.div`
  width: 100%;
  padding: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  @media (min-width: 768px) {
    width: 50%;
    padding: 30px 45px;
  }
`;

export const ColumnLeft = styled(Column)`
  background: url('') no-repeat top center;
  background-size: cover;
  align-items: flex-start;
  color: #ffffff;
`;

export const ColumnRight = styled(Column)`
  align-items: center;
`;

export const LogoContainer = styled.a`
  align-self: center;
`;

export const LogoContainerAppStore = styled.a`
width: 200px;
    height: 65px;
    position: absolute;
    margin: 10% 0 0 43%;
    z-index: 2;
`;

export const LogoContainerAppWebStore = styled.a`
    width: 240px;
    height: 90px;
    z-index: 2;
`;


export const Logo = styled.img`
  height: ${({height = 55}) => `${height}px`};
  margin-bottom: 30px;
`;

export const LogoAppStore = styled.img`
  width: 200px;
  height: 65px;
  margin: 50px auto;

  @media (max-width: 1500px) {
    width: 240px;
    height: 50px;
    margin: 10px auto;
  }

  @media (max-width: 1300px) {
    width: 240px;
    height: 90px;
    margin: 50px auto;
  }

  @media (max-width: 1100px) {
    width: 240px;
    height: 50px;
    margin: 10px auto;
  }
`;

export const LogoAppWeb = styled.img`
  height: 50px;
  margin: 50px auto;

  @media (max-width: 1500px) {
    width: 240px;
    height: 70px;
    margin: 30px auto;
  }

  @media (max-width: 1300px) {
    width: 240px;
    height: 50px;
    margin: 10px auto;
  }

  @media (max-width: 1100px) {
    width: 240px;
    height: 50px;
    margin: 10px auto;
  }

`;

export const LogoBgForm = styled.img`
  height: 60px;
  margin: 30px auto;

  @media (max-width: 1500px) {
    margin: 30px auto;
  }

  @media (max-width: 1300px) {
    margin: 30px auto;
    width: 100px;
    height: 40px;
  }

  @media (max-width: 1100px) {
    margin: 10px auto;
    width: 100px;
    height: 40px;
  }

`;

export const LogoRumina = styled.img`
  height: 60px;
  margin: 30px;
`;

export const BgLoginAppWebForm = styled.img`
    width: 100vw;
    height: 70vh;
    margin-top: 14%;
    position: absolute;
    z-index: 1;
`;

export const BgSelectAppWebForm = styled.img`
    width: 100vw;
    height: 100vh;
    margin-bottom: 14%;
    position: absolute;
    z-index: 1;
    background: #fff;
`;

export const LogoutBtn = styled.button`
  all: unset;
  cursor: pointer;
  align-self: flex-end;
  float: right;
  margin: 15px 0 0 15px;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  :hover {
    text-decoration: underline;
  }
`;

export const Notification = styled.div`
  width: 328px;
  background: #e3dfdf;
  border-radius: 4px;

  color: black;

  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  text-align: center;

  padding: 10px;
  margin-bottom: 20px;
`;
export const NotificationTitle = styled.div``;
export const NotificationSubtitle = styled.div``;
